import { ChevronDown, FileText, MessageSquare, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { PROVIDER_CHAT_UNAVAILABLE_MESSAGE } from "@api/shared-runtime/provider-chat-availability";
import type { EndedProviderRow } from "./ended-provider-types";

const ENDED_BY_PROVIDER_HINT =
  "Ended by provider — invite them again to reconnect";

export function EndedProviderActionsMenu({
  row,
  onChat,
  onViewCredentials,
  onReinstate,
}: {
  row: EndedProviderRow;
  onChat: () => void;
  onViewCredentials: () => void;
  onReinstate: () => void;
}) {
  const showEndedByProviderHint =
    row.endedByProvider && !row.capabilities.canReinstate;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="gap-2"
          aria-label={`Actions for ${row.name}`}
        >
          Actions
          <ChevronDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60">
        <DropdownMenuItem
          className="gap-3"
          disabled={!row.capabilities.canChat}
          title={
            row.capabilities.canChat
              ? undefined
              : PROVIDER_CHAT_UNAVAILABLE_MESSAGE
          }
          onSelect={onChat}
        >
          <MessageSquare className="h-4 w-4" />
          Chat
        </DropdownMenuItem>
        {row.credentialViewId && (
          <DropdownMenuItem className="gap-3" onSelect={onViewCredentials}>
            <FileText className="h-4 w-4" />
            View credentials
          </DropdownMenuItem>
        )}
        {row.capabilities.canReinstate && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem className="gap-3" onSelect={onReinstate}>
              <RotateCcw className="h-4 w-4" />
              Reinstate
            </DropdownMenuItem>
          </>
        )}
        {showEndedByProviderHint && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuLabel className="text-xs font-normal text-muted-foreground">
              {ENDED_BY_PROVIDER_HINT}
            </DropdownMenuLabel>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
